import { adminHttpClient } from '../commons/adminHttpClient'
import { RecurringReviewSectionStatus } from '../../domain/expenses/recurringReviewSectionStatus'
import { RecurringExpenseFrequency } from '../../domain/expenses/ReccuringExpenseFrequency'

export type ReviewPremiumRequest = {
  recurringExpenseId?: string
  overrideExpenseTypeId?: number
  expenseTypeReviewStatus: RecurringReviewSectionStatus
  overrideAmount?: number
  amountReviewStatus: RecurringReviewSectionStatus
  overrideStartDate?: string
  startDateReviewStatus: RecurringReviewSectionStatus
  overrideFrequency?: RecurringExpenseFrequency
  frequencyReviewStatus: RecurringReviewSectionStatus
  overrideEndDate?: string
  endDateReviewStatus: RecurringReviewSectionStatus
  messageToEmployee?: string
  messageToReviewer?: string
  ineligibleExpenseType?: boolean
  overrideName?: string
  nameReviewStatus: RecurringReviewSectionStatus
  isDuplicate: boolean
}

const reviewPremium = (values: ReviewPremiumRequest): Promise<string> => {
  return adminHttpClient.post('/Expenses/ReviewPremium', values)
}

export default reviewPremium
